import React, { useState } from 'react';
import { Button, Card, Form, Input, Modal, Typography, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { authAPI } from '../../services/api';

const { Title, Text } = Typography;

const MobileRegister = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    Modal.confirm({
      title: '确认注册',
      content: '注册后需要管理员审批才能登录，确定继续吗？',
      okText: '确认注册',
      cancelText: '取消',
      onOk: async () => {
        setLoading(true);
        try {
          await authAPI.register({ username: values.username, password: values.password });
          message.success('注册成功，请等待管理员审批');
          navigate('/login', { replace: true });
        } catch (error) {
          message.error(error.response?.data?.detail || '注册失败');
        } finally {
          setLoading(false);
        }
      },
    });
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', padding: 16, alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' }}>
      <Card style={{ width: '100%', maxWidth: 420 }}>
        <Title level={3} style={{ textAlign: 'center', marginBottom: 6 }}>
          注册 AutoTrader
        </Title>
        <Text type="secondary" style={{ display: 'block', textAlign: 'center', marginBottom: 16 }}>
          移动端
        </Text>

        <Form name="register" onFinish={onFinish} autoComplete="off" layout="vertical">
          <Form.Item name="username" label="用户名" rules={[{ required: true, message: '请输入用户名' }]}>
            <Input prefix={<UserOutlined />} placeholder="用户名" size="large" />
          </Form.Item>

          <Form.Item name="password" label="密码" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="密码" size="large" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} size="large" block>
              注册
            </Button>
          </Form.Item>

          <Form.Item style={{ textAlign: 'center', marginBottom: 0 }}>
            <Link to="/login">已有账户？去登录</Link>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default MobileRegister;
